module.exports = __webpack_public_path__ + "static/media/edit-pen.d8c7b0eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/edit-pen.svg
// module id = 462
// module chunks = 1